// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"42":"4ba7b4a9","312":"2817c7b2","810":"4bb015fa","867":"2817c7b2"}[chunkId] + ".css";
};